'use strict';

var React = require('react');
var styleHelper = require('../../helper/styleHelper');

var NumericStepper = React.createClass({

  render: function () {
    var rightDivStyle;
    var upTriangleStyle;
    var downTriangleStyle;
    var textDivStyle;
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var bgColor = styleHelper.getBackgroundColor(this.props);
    var color = styleHelper.getTextColor(this.props);
    var fontSize = styleHelper.getFontSize(this.props);
    var borderColor = styleHelper.getBorderColor(this.props);

    rightDivStyle = {
      borderLeftColor: borderColor
    };

    upTriangleStyle = {
      top: h / 2 - 7
    };

    downTriangleStyle = {
      top: h / 2 + 1
    };

    textDivStyle = {
      width: w - 21 ,// 几个像素边距
      color:color,
      backgroundColor:bgColor
    };

    return (<div className="border">
      <div style={rightDivStyle} className="right">
        <div style={upTriangleStyle} className="upTriangle"></div>
        <div style={downTriangleStyle} className="downTriangle"></div>
      </div>
      <div style={textDivStyle} className="text">
        <label style={{
          lineHeight: h + 'px',
          width: w - 26,
          fontSize: fontSize,
          fontFamily: this.props.textFontFamily,
          fontWeight: this.props.textStyles.fontWeight,
          fontStyle: this.props.textStyles.fontStyle,
          textDecoration: this.props.textStyles.textDecoration
        }}>{styleHelper.getText(this.props)}</label>
      </div>
    </div>);
  }
});

module.exports = NumericStepper;




/** WEBPACK FOOTER **
 ** ./src/views/Components/NumericStepper.jsx
 **/